import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { encryptedStorage } from 'src/utils/storage'

export interface User {
  id: string
  email: string
  phone: string
  company: string
  userName: string
  companyId: string
  companyCode: string
  userStatusId: string
  extranetUser: boolean
}

interface State {
  user: User | null
  clearUser: () => void
  setUser: (user: User) => void
}

export const useUserStore = create<State>()(
  persist(
    (set) => ({
      user: null,
      access: null,
      clearUser: () => set({ user: null }),
      setUser: (user: User) => set({ user }),
    }),
    {
      name: 'user-storage',
      storage: encryptedStorage(),
    }
  )
)
